module.exports = __webpack_public_path__ + "img/swem-ic.758ce513.png";